module.exports = __webpack_public_path__ + "static/media/foto1.b66675f1.png";